import {
  getAllConsignmentsDataSupportPortal,
} from '../../api/genericConsignmentView';
const viewControl = {
  pageTitle : 'Support Team Portal',
  buckets : [
    'retail_dc_all',
  ],
  navBar : {
    left : ['logistics_search'],
    right : [],
  },
  searchFilterOptions: [
    { key: 'referenceNumber', val: 'CN Number' },
    { key: 'destinationPhone', val: 'Customer Mobile No.' },
  ],
  fetchData : getAllConsignmentsDataSupportPortal,
};
const buckets = {
  retail_dc_all: {
    name: 'Support Team Portal',
    filters : [
    ],
    actions: [
    ],
    status_filter : [
    ],
    isSubBucket : false,
  },
};
export default { viewControl, buckets };
